module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_rectangular_marco_comida_48.5358d4f0.png";